import isValidRecipientAddress from 'owa-recipient-email-address/lib/utils/isValidRecipientAddress';
import getDisplayNameAndAddressFromRecipientString from 'owa-recipient-email-address/lib/utils/getDisplayNameAndAddressFromRecipientString';

export default function isValidAddressWithOptionalDisplayName(value: string) {
    const parsedNameAndAddress = getDisplayNameAndAddressFromRecipientString(value);
    return isValidRecipientAddress(parsedNameAndAddress.address);
}
